import React from 'react';

import {type MessageAttachment as MessageAttachmentType} from 'mattermost-redux/types/message_attachments';
import {type PostImage} from 'mattermost-redux/types/posts';

import {type TextFormattingOptions} from 'utils/text_formatting';

import MessageAttachment from './message_attachment';

type Props = {

    /**
     * The post id
     */
    postId: string;

    channelId: string;

    /**
     * Array of attachments to render
     */
    attachments: MessageAttachmentType[];

    /**
     * Options specific to text formatting
     */
    options?: Partial<TextFormattingOptions>;

    /**
     * Images object used for creating placeholders to prevent scroll popup
     */
    imagesMetadata?: Record<string, PostImage>;

    truncateTextAttachment?: boolean;
}

export default class MessageAttachmentList extends React.PureComponent<Props> {
    static defaultProps = {
        imagesMetadata: {},
    }

    render() {
        const content = [] as JSX.Element[];
        this.props.attachments.forEach((attachment, i) => {
            content.push(
                <MessageAttachment
                    attachment={attachment}
                    postId={this.props.postId}
                    channelId={this.props.channelId}
                    key={'att_' + i}
                    options={this.props.options}
                    imagesMetadata={this.props.imagesMetadata}
                    truncateTextAttachment={this.props.truncateTextAttachment}
                />,
            );
        });

        return (
            <div
                id={`messageAttachmentList_${this.props.postId}`}
                className='attachment__list'
            >
                {content}
            </div>
        );
    }
}
